import { produce } from 'immer';

export const STATUS = {
  OK: 'success',
  ERR: 'error'
};

type ContactFieldOption = {
  display: boolean;
  isRequired: boolean;
  init: string;
}

type ContactOptions = {
  css: {
    textAlign: 'center' | 'left' | 'right';
    fullWidth: boolean
  },
  fields: { [key: string]: ContactFieldOption };
}

const DEFAULT_OPTIONS: ContactOptions = {
  css: {
    textAlign: 'center',
    fullWidth: false
  },
  fields: {
    name: { display: true, isRequired: true, init: '' },
    email: { display: true, isRequired: true, init: '' },
    telephone: { display: true, isRequired: true, init: '' },
    comment: { display: true, isRequired: true, init: '' }
  }
};

export const CONTACT_FORM_OPTIONS = {
  DEFAULT: DEFAULT_OPTIONS,
  noSearchResult: (comment: string) => produce(DEFAULT_OPTIONS, (draft) => {
    draft.fields.comment.init = comment;
  }),
  outOfStock: (comment: string) => produce(DEFAULT_OPTIONS, (draft) => {
    draft.css = { textAlign: 'left', fullWidth: true };

    draft.fields.name.display = false;

    draft.fields.comment.display = false;
    draft.fields.comment.init = comment;
  })
};

export const CONTACT_FORM_TYPES = {
  NO_SEARCH_RESULT: 'noSearchResult',
  OUT_OF_STOCK: 'outOfStock',
};
